export { default } from './CompanyAdminEditModal';
